module.exports = __webpack_public_path__ + "img/13.c0d9a017.svg";